import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import Button from '../../../../../../components/Button';
import { i18nNS } from '../../../../../../i18n';
import { ChartPalette } from '../../../../../../styles/chart-palette';
import { getAlphabetFromIndex } from '../../../../../../utils/helper';
import { MAX_NO_OF_POLL_QUESTION_OPTIONS } from '../../../constants';
import QuestionOption from './QuestionOption';
import { Root, unpublishedQuestionOptionsClasses } from './styles';
import useUnpublishedQuestionOptions, { UseUnpublishedQuestionOptions } from './vm';

export interface UnpublishedQuestionOptionsProps extends UseUnpublishedQuestionOptions {
  className?: string;
}

const UnpublishedQuestionOptions = ({ className, ...vmProps }: UnpublishedQuestionOptionsProps) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { formMethods } = vmProps;
  const { control } = formMethods;
  const {
    bottomElementRef,
    fields,
    canRemoveOption,
    canAutoFocusOption,
    handleAppendOption,
    handleRemoveOption,
    handleChangeQuestionOption,
    handleBlurQuestionOption,
  } = useUnpublishedQuestionOptions(vmProps);

  return (
    <Root className={className}>
      {fields.map((option, index) => {
        const alphabet = getAlphabetFromIndex(index);
        return (
          <QuestionOption
            key={option.optionId}
            control={control}
            name={`options.${index}.text`}
            initialValue={option.text}
            label={alphabet}
            color={ChartPalette[index]}
            placeholder={t('option_N', { ns: i18nNS.POLL, num: alphabet })}
            canClearRichText={!canRemoveOption}
            canRemoveOption={canRemoveOption}
            onDelete={handleRemoveOption(index)}
            onChange={handleChangeQuestionOption}
            onBlur={handleBlurQuestionOption}
            autoFocus={canAutoFocusOption}
            className={unpublishedQuestionOptionsClasses.questionOption}
          />
        );
      })}
      <Button
        variant="text"
        onClick={handleAppendOption}
        fullWidth
        disabled={fields.length >= MAX_NO_OF_POLL_QUESTION_OPTIONS}
        className={unpublishedQuestionOptionsClasses.addAnotherOptionButton}
      >
        {t('plus_add_another_option', { ns: i18nNS.POLL })}
      </Button>
      <Box ref={bottomElementRef} width="100%" height="1px" lineHeight="1px" />
    </Root>
  );
};

export default UnpublishedQuestionOptions;
